import { BorderRadiusTokens, ColorTokens, } from '@voltmoney/schema';
import React from 'react';
import { Shimmer } from '../shimmer/Shimmer';
const MemberCardShimmer = () => {
    return (React.createElement(Shimmer, { height: 160, width: '100%', borderRadius: BorderRadiusTokens.BR1, backgroundColor: ColorTokens.Grey_600 }));
};
export default MemberCardShimmer;
